/**
 * useDocumentTitle — set the browser tab title for the current page.
 *
 * The app is a single SPA with one static <title> in index.html (default
 * "LegacyOrb"). Customer-facing surfaces (the /start funnel, /account) and the
 * admin dashboard set their own title so the tab never leaks an internal label
 * like "Admin Dashboard" on a customer page (ClickUp 86baeu544).
 *
 * Restores the previous title on unmount so back-navigation doesn't strand a
 * stale title.
 */
import { useEffect } from 'react';

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
